import React from 'react';

export const TemplateReader = () => {

    return (
        <p>{localStorage.getItem("template")}</p>
    )
} 